import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { trackGuestEvent } from "@/lib/guestEvents";

const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [productSheetId, setProductSheetId] = useState(null);
  const [editLineId, setEditLineId] = useState(null);
  const [cartOpen, setCartOpen] = useState(false);
  const [waiterOpen, setWaiterOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [staffRatingOpen, setStaffRatingOpen] = useState(false);

  const openProduct = useCallback((id, lineId = null) => {
    if (!lineId) trackGuestEvent("product.view", { productId: id });
    setEditLineId(lineId);
    setProductSheetId(id);
  }, []);
  const closeProduct = useCallback(() => { setProductSheetId(null); setEditLineId(null); }, []);
  const openCart = useCallback(() => setCartOpen(true), []);
  const closeCart = useCallback(() => setCartOpen(false), []);
  const openWaiter = useCallback(() => setWaiterOpen(true), []);
  const closeWaiter = useCallback(() => setWaiterOpen(false), []);
  const openServices = useCallback(() => setServicesOpen(true), []);
  const closeServices = useCallback(() => setServicesOpen(false), []);
  const openFeedback = useCallback(() => { setServicesOpen(false); setFeedbackOpen(true); }, []);
  const closeFeedback = useCallback(() => setFeedbackOpen(false), []);
  const openStaffRating = useCallback(() => setStaffRatingOpen(true), []);
  const closeStaffRating = useCallback(() => setStaffRatingOpen(false), []);

  const value = useMemo(
    () => ({
      productSheetId, editLineId, cartOpen, waiterOpen, servicesOpen, feedbackOpen, staffRatingOpen,
      openProduct, closeProduct, openCart, closeCart, openWaiter, closeWaiter,
      openServices, closeServices, openFeedback, closeFeedback, openStaffRating, closeStaffRating,
    }),
    [productSheetId, editLineId, cartOpen, waiterOpen, servicesOpen, feedbackOpen, staffRatingOpen, openProduct, closeProduct, openCart, closeCart, openWaiter, closeWaiter, openServices, closeServices, openFeedback, closeFeedback, openStaffRating, closeStaffRating]
  );
  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
}

export function useUI() {
  const ctx = useContext(UIContext);
  if (!ctx) throw new Error("useUI must be used within UIProvider");
  return ctx;
}
